import actions from './actions';
import getters from './getters'
import mutations from './mutations';


const getDefaultState = () => ({
  products : [],
  selectedProduct : null,
  loadingSelectedProduct : false,
  selectedIndex : null,
  selectedProductItems : [],
  selecteProductPurchaseOrders : [],
  orderBy:{orderName : 'productName',  direction:'ASC'},
  outDated : true,
  loading : false,
  loadingSelectedProductItems : false,
  loadingSelectedProductPurchaseOrders : false,
  searchTerms :'',
  mode : 'tile',
  sort_icon : 'el-icon-caret-bottom',
  icons : {
    'DESC' : 'el-icon-caret-bottom',
    'ASC' : 'el-icon-caret-top'
  },
  page : 1,
  pages : 0, //nombre de page total
  count : 0,
  limit : 50,
  inventoryId : null,
  inventory : null,
  globalInventoryReportLoading:false,
  filters : {
    productWithQuantity : true,
    productInSupply : true,
    productPublishedInd: null,
    providerId : null,
    checkedTags : [],
  },
  columns: [],
  columnsOptions : [
    {
      code: "product",
      default : true,
    },
    {
      code: "provider",
      default: false,
    },
    {
      code: "type",
      default : true,
    },
    {
      code : "tags",
      default: "false",
    },
    {
      code: "format",
      default : true,
    },
    {
      code: "uvc",
      default : true,
    },
    {
      code : "price",
      default : true,
    },
    {
      code: "priceDetail",
      default: false,
    },
    {
      code: "agencyFee",
      default: false,
    },
    {
      code: "delay",
      default: true,
    },
    {
      code : "qty",
      default: true,
    },
    {
      code: "qtyToReceive",
      default: false,
    },
    {
      code: "qtyReserved",
      default: false,
    },
    {
      code: "qtyReservedNextBatch",
      default: false,
    },
    {
      code: "qtyInventory",
      default: false,
    },
    {
      code: "qtyInCommand",
      default: false,
    },
    {
      code: "qtySold",
      default: false,
    }
  ],
});

export default {
  namespaced: true,
  state: getDefaultState(),
  actions,
  getters,
  mutations,
  getDefaultState,
};
